import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for Trip
 *
 */

const Trip = lazyLoad(
  () => import('app/modules/Trip'),
  (module) => module.default,
);

export default Trip;
